import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { goToLogin, isLeavingForLogin } from "@/lib/auth-utils";
import { captureAuthEvent } from "@/lib/sentry";

/**
 * Leave the signed-in app as soon as Firebase drops the user. That happens
 * when the refresh token stops working (password changed on another device,
 * account disabled) or another tab signs out; staying put left a shell where
 * every request failed with AUTH_MISSING. Firebase has already cleared the
 * session, so this only navigates. A sign-out already in progress wins, so
 * its reason is the one the login page shows.
 */
export function useSignOutWhenSessionEnds(): void {
  const { isReady, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isReady || isAuthenticated || isLeavingForLogin()) return;
    captureAuthEvent("session-ended");
    goToLogin("session-expired");
  }, [isReady, isAuthenticated]);
}
